(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'LivePlannerNewPrimaryClient',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		// resume the session with primary client
		$('.lp-session-resume-primary').on('click', function _resumeSession(e) {
			e.preventDefault();

			Adzuki.Ajax.get('/LivePlanner/resume/')
			.then(function _resume(response) {
				var $modal = $('#modalWindow');

				// just close the modal
				$modal.modal('hide');
				$modal.find('.modal-body').html('');
			});
		});
	};

	form.success = function success(response)
	{
		var $modal         = $('.modal');
		var url            = null;
		var client_id      = null;
		var client_session = null;

		if (Adzuki.Form.hasError(response)) {
			return false;
		}

		client_id      = response['data']['client_id'];
		client_session = response['data']['web_session_id'];
		url            = '/LivePlanner/designateNewPrimaryClient/';
		url           += client_id + '/';
		url           += client_session;

		Adzuki.Ajax.get(url)
		.then(function _designatePrimary(response) {
			var new_title = null;

			if (response.error) {
				Adzuki.StatusMessage('error', response.error);
				return;
			}

			new_title = 'LivePlanner Session with ' + response.primary_client;

			Adzuki.StatusMessage('success', response.primary_client + ' is the new primary client for this session.');

			$('h3.page-title').text(new_title);
			$(document).prop('title', new_title);
			$('#liveplannerprocessor-web_session_id').val(client_session);

			$modal.modal('hide');
		});
	};
}(jQuery, window.Adzuki || {}));
